import queryMenuApp from './queryMenuApp';
import queryMy from './queryMy';
import queryAppInfo from './queryAppInfo';
import getAppCode from './getAppCode';
import getAppToken from './getAppToken';
import bindAuthorize from './bindAuthorize';

export default {

    /** 查询菜单可以显示的APP */
    queryMenuApp,

    /** 查询我们应用可以显示的APP */
    queryMy,

    /** 查询APP的详情 */
    queryAppInfo,
    /** 申请Code */
    getAppCode,
    /** 获取嵌入App的Token */
    getAppToken,
    bindAuthorize, // 绑定授权
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/appStore/index.ts